import {
  EMAIL_CREATION_FORM_FIELD_NAME_FILES_FROM_STORAGE,
  useEmailCreationFormInitialValues,
  useEmailGetActiveAccountForCreate,
} from '../../../../Email'
import { MINIMIZED_MODAL_SCOPE } from '../../../../Modal'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { RequestProfileEmailAudienceModal } from '../../../RequestProfileEmailAudienceModal'
import {
  EMAIL_AUDIENCE_BY_RECIPIENT_TYPE,
  getToRecipients,
  RequestProfileTabEmailsCreateEmailPopUp,
} from '../../../RequestProfileTabEmails'

export function useRequestProfileTabDocumentsSendViaEmail() {
  const { requestContractors, requestData } = useRequestProfileContext()

  const { activeAccountForCreate } = useEmailGetActiveAccountForCreate({
    withServiceAccount: true,
  })

  const emailInitial = useEmailCreationFormInitialValues({
    account: activeAccountForCreate,
  })

  function handleSendViaEmail({
    closeEmailFormModal,
    closeModal,
    files,
    setEmailFormModal,
    setModal,
    unselectAllPages,
    onReload,
  }) {
    function handleSendSuccess() {
      unselectAllPages?.()
      onReload?.()
    }

    function handleOpenEmailCreatePopUp({ audience, initialValues }) {
      setEmailFormModal(
        <RequestProfileTabEmailsCreateEmailPopUp
          isLeaveGuardEnabled
          audience={audience}
          initialValues={initialValues}
          minimizedModalScope={MINIMIZED_MODAL_SCOPE.REQUEST_PROFILE_TAB}
          requestData={requestData}
          requestId={requestData?.id}
          onClose={closeEmailFormModal}
          onSendSuccess={handleSendSuccess}
        />
      )
    }

    function handleSubmitAudience({ recipientType }) {
      closeModal()

      handleOpenEmailCreatePopUp({
        audience: EMAIL_AUDIENCE_BY_RECIPIENT_TYPE[recipientType],
        initialValues: {
          ...emailInitial,
          [EMAIL_CREATION_FORM_FIELD_NAME_FILES_FROM_STORAGE]: files,
          to: getToRecipients({
            recipientType,
            requestContractors,
            requestData,
          }),
        },
      })
    }

    setModal(
      <RequestProfileEmailAudienceModal
        onClose={closeModal}
        onSubmit={({ recipientType }) =>
          handleSubmitAudience({ recipientType })
        }
      />
    )
  }

  return { handleSendViaEmail }
}
